import { render, staticRenderFns } from "./assessment-history-scale.vue?vue&type=template&id=b0f2ebfe&scoped=true&"
import script from "./assessment-history-scale.vue?vue&type=script&lang=js&"
export * from "./assessment-history-scale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f2ebfe",
  null
  
)

export default component.exports